import { useT } from '../../i18n';
import { GeranceInvolvementsView } from './GeranceInvolvementsView';

// [Proposition: implications] Tab on the proposals page: the same table as
// Gérance > Implications, so the proposal can be reviewed in place.
export function ImplicationsProposal() {
  const { t } = useT();
  return (
    <>
      <p className="text-sm text-ink-3 mb-16">{t('impl.where')}</p>
      <GeranceInvolvementsView />
    </>
  );
}
